export default __webpack_public_path__ + "static/media/gift.781e257e.svg";